import { useWebSocket } from "@/react/hooks/useWebSocket";

import { useMemberDeactivated } from "./useMemberDeactivated";

interface UseChatRoomChannelWebSocketProps {
  canCreateConnection?: boolean;
  communityMemberId: number | undefined;
  deps?: unknown[];
  onMessageReceive: (data: any) => void;
}

export const useChatRoomChannelWebSocket = ({
  communityMemberId,
  onMessageReceive,
  canCreateConnection = true,
  deps = [],
}: UseChatRoomChannelWebSocketProps) => {
  const { isDeactivated, onMemberDeactivatedEvent } =
    useMemberDeactivated(communityMemberId);

  useWebSocket(
    {
      channel: "ChatRoomChannel",
      contact_id: communityMemberId,
      onMessageReceive: (data: any) => {
        onMemberDeactivatedEvent(data);
        if (data.event !== "memberDeactivated") {
          onMessageReceive(data);
        }
      },
      canCreateConnection:
        canCreateConnection && Boolean(communityMemberId) && !isDeactivated,
    },
    [communityMemberId, canCreateConnection, isDeactivated, ...deps],
  );
};
